"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { Wrap } from '../Wrap/Wrap.mjs';

const Content = flowComponent("Content", (props) => {
  const {
    children,
    elementType = "div",
    ref,
    clearPropsContext = true,
    ...rest
  } = props;
  const Element = elementType;
  return /* @__PURE__ */ jsx(Wrap, { if: clearPropsContext, children: /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(Element, { ref, ...rest, children }) }) });
});

export { Content, Content as default };
//# sourceMappingURL=Content.mjs.map
